// @flow
import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';

type UseSchedule = () => {
  schedule: (string, number, string[]) => void
}

const useSchedule: UseSchedule = () => {
  const { userId } = useSelector(mapStateToProps);

  const [__schedule] = useMutation(MUTATION, {
    refetchQueries: [
      'getPendingDeployment',
      'scheduledDeployment',
      'getNavData'
    ]
  });
  const schedule = (versionId, deployAt, pageVersionIds) => __schedule({
    variables: {
      versionId, deployAt, userId, pageVersionIds
    }
  });
  return {
    schedule
  };
};

const MUTATION = gql`
mutation schedule($versionId: String!, $deployAt: Float, $userId: String,
  $pageVersionIds: [String]) {
  schedule( versionId: $versionId, deployAt: $deployAt, userId: $userId,
    pageVersionIds: $pageVersionIds)
}
`;

/* =============================================================================
=    Redux
============================================================================= */
const mapStateToProps = state => ({
  userId: state.app.user && state.app.user._id
});

export default useSchedule;
